module.exports = __webpack_public_path__ + "img/newsImg11-10.6e98086b.png";